import { moduleRequest } from '@/utils/request'

const request = moduleRequest(`/sys/dataStatistic/`)

export default {
	// 获取图片验证码
	uvAdd(data) {
		return request('uvAdd', data, 'post')
	},
	// 获取上报用户页面访问记录
	pvAdd(data) {
		return request('pvAdd', data, 'post')
	},
}
